import React, { FC } from 'react';

interface YQImagePropsType {
  src: string;
  width: number;
  height: number;
  style?: React.CSSProperties;
}

const YQImage: FC<YQImagePropsType> = function YQImage({
  src,
  width,
  height,
  style,
}) {
  return (
    <img
      src={src}
      alt=""
      style={{
        width: `${width / 100}rem`,
        height: `${height / 100}rem`,
        ...style,
      }}
    />
  );
};

export default YQImage;

YQImage.defaultProps = {
  style: {},
};
